import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';
import { useIsSellerFeatureEnabled } from '../../hooks/use-is-seller-feature-enabled';
import { SellerFeatures } from '../../enums/seller-features';

export const useEnableBundledProducts = () => {
  const isFeatureFlagEnabled = useFeatureFlag(FeatureFlagDeclarations.enableBundledProducts);
  const isSellerFeatureEnabled = useIsSellerFeatureEnabled(SellerFeatures.ProductBundles);
  return isFeatureFlagEnabled || isSellerFeatureEnabled;
};
